module.exports = __webpack_public_path__ + "files/9ff64a8fc61b59fa5f7e7272d1d5d04c.png";